var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.357,
    height: 32.236,
    viewBox: "0 0 58.357 32.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hand_2",
    "data-name": "Hand 2",
    transform: "translate(-2241.263 -165.655) rotate(7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M2248.128-99.516s1.361-1.154,1.956-1.709a40.549,40.549,0,0,1,3.567-2.835,12.794,12.794,0,0,1,4.536-1.694,16.319,16.319,0,0,1,4.166.214,11.025,11.025,0,0,0,4.716-.107,31.2,31.2,0,0,0,4.72-1.563c.441-.3,4.6-2.029,5.351-1.823a2.4,2.4,0,0,1,1.72,2.395c.138,1.586-1.323,2.37-2.3,3.673a14.189,14.189,0,0,1-4.105,3.629c-.882.278,1.832,3.195,4.892,3.512s10.784,2.888,14.633.69,9.663-8.244,11.289-3.713-14.075,17.436-25.922,15-19.589-7.234-22.832-6.765-5.054.188-6.022-2.629A14.608,14.608,0,0,1,2248.128-99.516Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M2276.586-98.474s1.492.207,4.113-1.481,6.479-5.332,6.916-5.51,2.585-.652,3.6.444-.653,2.828-1.163,3.42a15.607,15.607,0,0,1-3.349,2.749c-1.508.9-2.324.882-4.253.882S2276.586-98.474,2276.586-98.474Z",
    transform: "matrix(1, -0.017, 0.017, 1, 8.148, 42.238)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M2271.949-98.854a24.883,24.883,0,0,0,4.482-2.962c1.74-1.566,2.785-3.655,3.829-3.829a1.912,1.912,0,0,1,2.31,1.113c.24.893-4.067,4.388-5.075,4.839a11.417,11.417,0,0,1-2.327.715A13.358,13.358,0,0,1,2271.949-98.854Z",
    transform: "matrix(1, -0.017, 0.017, 1, 10.307, 41.499)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M2271.816-99.608a24.306,24.306,0,0,0,3.99-4.818c.592-1.234,3.268-1.419,3.206,0s-4.171,5.274-6.225,5.212-1.712-.247-1.712-.247A.958.958,0,0,0,2271.816-99.608Z",
    transform: "translate(10.488 -276.37) rotate(7)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/Hand.ce37a49e231b9e48f53006b79f251972.svg";
export { ForwardRef as ReactComponent };